/**
 * اطلاعات کسب‌وکار — تنها جایی که باید برای اینماد ویرایش کنید.
 *
 * این اطلاعات در فوتر همه‌ی صفحات و در صفحه‌ی «قوانین و مقررات» نمایش داده می‌شود.
 * ⚠️ همه‌ی مقادیر باید دقیقاً با مدارکی که در سامانه‌ی اینماد ثبت می‌کنید یکی باشد
 *    (نام، نشانی، تلفن، شماره پروانه کسب).
 * فیلدهای خالی ('' یا []) در سایت نمایش داده نمی‌شوند.
 */
const siteInfo = {
  brandName: 'جواهری نور',

  // نام و نام خانوادگی صاحب کسب‌وکار (یا نام شرکت) — دقیقاً مطابق مدارک اینماد
  legalName: '',

  // یک جمله‌ی کوتاه زیر نام فروشگاه. ادعاهایی مثل «۲۰ سال تجربه» فقط در صورتی بنویسید که واقعی و قابل اثبات باشد.
  tagline: 'فروشگاه آنلاین طلا و جواهر',

  domain: 'noorjewerly.ir',

  // شماره‌هایی که واقعاً پاسخگو هستند
  phones: ['09131965682'],

  // ایمیل رسمی (مثلاً info@noorjewerly.ir) — خالی بماند نمایش داده نمی‌شود
  email: '',

  // مثال: 'شنبه تا پنجشنبه، ۹ تا ۲۰'
  workingHours: '',

  // نشانی فیزیکی فروشگاه/شعبه‌ها — اینماد نشانی واقعی و قابل‌پیگیری می‌خواهد
  branches: [
    { title: 'شعبه کرمان', address: 'کرمان، خیابان گنجعلی خان کوچه تجلی 3' },
    { title: 'شعبه رفسنجان', address: 'رفسنجان، خیابان شهیدبهشتی کوچه 31 ، پاساژ گلستان ورودی اصلی' },
  ],

  // مجوزها — فقط موارد واقعی را بنویسید
  licenses: {
    businessLicenseNumber: '', // شماره پروانه کسب
    unionName: '',             // مثلاً: اتحادیه صنف طلا، جواهر و نقره
  },

  social: {
    instagramKerman: 'https://www.instagram.com/noorjwlrs?igsh=Y3N1dnVoZmxzd3d0',
    instagramRafsanjan: 'https://www.instagram.com/jewelry_noor_?igsh=dzExeG16NTdpZ29q',
    telegram: 'https://t.me/Noorjwlrs',
  },

  /**
   * نماد اعتماد الکترونیکی (اینماد)
   * ⚠️ تا وقتی اینماد نگرفته‌اید این دو مقدار را خالی بگذارید؛ نماد نمایش داده نمی‌شود.
   * بعد از تأیید، از کد HTML که سایت اینماد می‌دهد:
   *   https://trustseal.enamad.ir/?id=123456&Code=AbCdEf...
   *   مقدار id را در id و مقدار Code را در code بگذارید.
   */
  enamad: {
    id: '',
    code: '',
  },
};

export default siteInfo;
